function indeterminate(state) {
	return state.appConfig.isLoading;
}

function snackbar(state) {
	return state.appConfig.snackbar;
}

const methods = {
	indeterminate,
	snackbar,
};

export default methods;



// WEBPACK FOOTER //
// ./src/store/getters.js